import axios from "axios";

// Set config defaults when creating the instance
const ApiClient = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "http://localhost:8000/rsvp" : "https://api.jeanandandrew.com/rsvp"
});

export default ApiClient;
